/* eslint-disable global-require */
module.exports = ['artprice.Bio.Glossary.m8'];
